import { render } from "./FTLOrderUpdate.vue?vue&type=template&id=14b67c53&scoped=true&ts=true"
import script from "./FTLOrderUpdate.vue?vue&type=script&lang=ts"
export * from "./FTLOrderUpdate.vue?vue&type=script&lang=ts"

import "./FTLOrderUpdate.vue?vue&type=style&index=0&id=14b67c53&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b67c53"]])

export default __exports__